/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Download_OfflineInputs */

const en_mobile_benefits_download_offline = /** @type {(inputs: Mobile_Benefits_Download_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download and listen offline`)
};

const es_mobile_benefits_download_offline = /** @type {(inputs: Mobile_Benefits_Download_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga y escucha sin conexión`)
};

/**
* | output |
* | --- |
* | "Download and listen offline" |
*
* @param {Mobile_Benefits_Download_OfflineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_download_offline = /** @type {((inputs?: Mobile_Benefits_Download_OfflineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Download_OfflineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_download_offline(inputs)
	return en_mobile_benefits_download_offline(inputs)
});